import styled from '@emotion/styled';

import type { TImgWrapperStyleConfig } from './vehicle-message.types';

import { carIcon, motoIcon } from '@/utils/helpers';

export const VehicleMessage = styled.a`
	width: 240px;
	min-height: 70px;
	border: 1px solid ${({ theme }) => theme.colors.gray5};
	border-radius: 8px;
	display: flex;
	background: #fff;
`;

export const ImgWrapper = styled.div<TImgWrapperStyleConfig>`
	overflow: hidden;
	min-width: 100px;
	background-image: ${({ imgSrc, isCar }) =>
		'url(' + imgSrc + '), url(' + (isCar ? carIcon : motoIcon) + ')'};
	background-repeat: no-repeat;
	background-position: center;
	background-size: cover, auto;
	border-radius: 8px 0 0 8px;
`;
export const ContentWrapper = styled.div`
	padding: 8px 16px 8px 11px;
	display: flex;
	flex-direction: column;
	justify-content: space-around;
	justify-content: space-evenly;
`;

export const Title = styled.h3`
	font-size: 12px;
	color: ${({ theme }) => theme.colors.gray1};
	font-weight: 500;
	line-height: 18px;
`;

export const Description = styled.p`
	padding-top: 5px;
	font-weight: 500;
	font-size: 8px;
	line-height: 12px;
	color: ${({ theme }) => theme.colors.gray3};
	white-space: nowrap;
	width: 110px;
	overflow: hidden;
`;
